import { buildRequest, APIInterfaceWithActiveStatusI } from '.';

class users implements APIInterfaceWithActiveStatusI {
  getAll = () => (
    buildRequest('GET', '/users')
  )

  getOne = (username: string) => (
    buildRequest('GET', `/users/name/${username}`)
  )

  register = (formData: any) => (
    buildRequest('POST', '/users', formData)
  )

  update = (targetId: string, formData: any) => (
    buildRequest('PUT', `/users/${targetId}`, formData)
  )

  delete = (targetId: string) => (
    buildRequest('DELETE', `/users/${targetId}`)
  )

  setActivateStatus = (userId: string, newStatus: boolean) => (
    buildRequest('PUT', `/users/${userId}/${newStatus ? 'activate' : 'deactivate'}`)
  )
}

export default users;
